function DateFilter (moment) {
  function filter (value) {
    return moment(value).format('DD/MM/YY') + ' às ' + moment(value).format('HH:mm') + 'h'
  }

  return {
    filter
  }
}

export default DateFilter
